<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Báo cáo tình trạng xe tuyến"
          :link="[
            {
              text: 'Tình trạng xe tuyến',
              href: '../busCheckin'
            }
          ]"
        />
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <BusCheckinFilter ref="busTrackingFilter" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <BusCheckinDataTable ref="busCheckinDataTable" @paginationChange="paginationChange" />
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import BusCheckinFilter from '@/modules/bus/BusCheckin/BusCheckinFilter.vue'
import BusCheckinDataTable from '@/modules/bus/BusCheckin/BusCheckinDataTable.vue'
import { mapActions, mapMutations } from 'vuex'

export default {
  components: {
    Breadcrumbs,
    BusCheckinFilter,
    BusCheckinDataTable
  },
  props: {},
  data() {
    return {}
  },
  async created() {
    this.resetData()
    await this.getBusSchedule()
  },
  methods: {
    ...mapActions('BusCheckin', ['fetchBusTracking', 'getBusSchedule']),
    ...mapMutations({
      resetData: 'BusCheckin/resetData'
    }),
    async paginationChange(page) {
      await this.$refs.busTrackingFilter.getBusTrackingByPagination(page.page, page.itemsPerPage)
    }
  }
}
</script>
<style scoped></style>
